// Reusable data-export helpers (CSV / Excel / PDF) for grid/list pages.
import * as XLSX from 'xlsx';

// columns: [{ key, label }]  ·  rows: array of objects
const cell = (row, key) => {
  const v = row[key];
  if (v === null || v === undefined) return '';
  if (typeof v === 'object') return JSON.stringify(v);
  return v;
};

export function exportToCSV(rows, columns, filename = 'export') {
  const header = columns.map(c => `"${c.label}"`).join(',');
  const body = rows.map(r => columns.map(c => `"${String(cell(r, c.key)).replace(/"/g, '""')}"`).join(',')).join('\n');
  const blob = new Blob([header + '\n' + body], { type: 'text/csv;charset=utf-8;' });
  download(blob, `${filename}.csv`);
}

export function exportToXLSX(rows, columns, filename = 'export') {
  const data = rows.map(r => { const o = {}; columns.forEach(c => o[c.label] = cell(r, c.key)); return o; });
  const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(c => c.label) });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Export');
  XLSX.writeFile(wb, `${filename}.xlsx`);
}

export function exportToPDF(rows, columns, filename = 'export', title = '') {
  const head = columns.map(c => `<th style="text-align:left;border-bottom:1px solid #999;padding:6px 8px;font-size:12px">${c.label}</th>`).join('');
  const body = rows.map(r => `<tr>${columns.map(c => `<td style="padding:5px 8px;border-bottom:1px solid #eee;font-size:11px">${String(cell(r, c.key))}</td>`).join('')}</tr>`).join('');
  const w = window.open('', '_blank');
  if (!w) return;
  w.document.write(`<html><head><title>${filename}</title></head><body>
    <h3 style="font-family:sans-serif">${title || filename}</h3>
    <div style="font-family:sans-serif;font-size:11px;color:#666;margin-bottom:8px">Generated ${new Date().toLocaleString()} · ${rows.length} rows</div>
    <table style="border-collapse:collapse;width:100%;font-family:sans-serif"><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>
    <script>window.onload=()=>window.print()</script></body></html>`);
  w.document.close();
}

function download(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
